import { render, staticRenderFns } from "./TelegramContactList.vue?vue&type=template&id=3b99bcc4&scoped=true"
import script from "./TelegramContactList.vue?vue&type=script&lang=js"
export * from "./TelegramContactList.vue?vue&type=script&lang=js"
import style0 from "./TelegramContactList.vue?vue&type=style&index=0&id=3b99bcc4&prod&lang=scss"
import style1 from "./TelegramContactList.vue?vue&type=style&index=1&id=3b99bcc4&prod&scoped=true&lang=scss"
import style2 from "./TelegramContactList.vue?vue&type=style&index=2&id=3b99bcc4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b99bcc4",
  null
  
)

export default component.exports